import { Schema } from 'normalizr';
import { baseSchema } from '../../../types/schema';
import { keys } from './keys';
import { unitSchema } from '../Units/schema';

/**
 * UnitSystems Entity Schema
 *
 * Normalizr schema for UnitSystems entities.
 * Defines relationships to Unit entities for length, weight, and density measurements.
 */
const unitSystemSchema = baseSchema(keys.state, {
  unitLength: { schema: unitSchema, isId: true },
  unitWeight: { schema: unitSchema, isId: true },
  unitDensity: { schema: unitSchema, isId: true },
});

export { unitSystemSchema };

// Type assertion for better TypeScript support
export const typedUnitSystemSchema: Schema = unitSystemSchema;